import React from 'react';
import { Hero } from '../Hero';
import { RunningStrip } from '../RunningStrip';
import { ServiceMenu } from '../ServiceMenu';
import { ReviewsSection } from '../ReviewsSection';
import { WhyChooseUs } from '../WhyChooseUs';
import { FAQSection } from '../FAQSection';
import { Footer } from '../Footer';
import { SelectedServiceDetails } from '../BookingModal';
import { navigateTo } from '../../utils/router';

interface HomePageProps {
  selectedItems: SelectedServiceDetails[];
  onToggleService: (id: string, name: string, price: number) => void;
  activeMenuCategory: string | null;
}

export const HomePage: React.FC<HomePageProps> = ({
  selectedItems,
  onToggleService,
  activeMenuCategory
}) => {
  return (
    <div className="multipage-view home-page-view">
      {/* Hero Section */}
      <Hero
        onOpenBookingModal={() => navigateTo('/cart')}
        onNavigateToServices={() => navigateTo('/services')}
      />

      {/* Running Highlights Strip */}
      <RunningStrip />

      {/* A La Carte Price Menu - Directly after Hero */}
      <ServiceMenu
        selectedServices={selectedItems.map((s) => s.id)}
        onToggleService={onToggleService}
        initialCategory={activeMenuCategory}
        onSelectCategory={(catId) => navigateTo('/services', { category: catId })}
      />

      {/* Customer Reviews & Ratings - Placed directly below services */}
      <ReviewsSection />

      {/* Why Choose Us */}
      <WhyChooseUs />

      {/* SEO-Optimized FAQ & Service Areas */}
      <FAQSection />

      {/* Footer */}
      <Footer />
    </div>
  );
};
